import { createContext, useContext } from "react";

export const useSirenStateContext = () => useContext(SirenStateContext);

export const SirenStateContext = createContext({ isMuted: true, setIsMuted: (_value: boolean) => {}, playStartSiren: false, setPlayStartSiren: (_value: boolean) => {} });
